module.exports = __webpack_public_path__ + "static/media/young_engineers_logo.6c123553.png";